/* eslint-disable max-len */
import config from 'config';
import { SEARCH } from 'config/fe-routes';
import Script from 'next/script';
import urlJoin from 'url-join';
import { tagManagerId } from 'utils/analytics';

import { useLanguage } from '../../hooks/useLanguage';

const GlobalScripts = () => {
  const { country, language } = useLanguage();

  const metaUrl = config.get(`web.meta.url[${country}]`) ?? '';

  return (
    <>
      {/* Google searchlink json */}
      <Script
        id="google-searchlink-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            url: metaUrl,
            potentialAction: {
              '@type': 'SearchAction',
              target: urlJoin(metaUrl, SEARCH('', language).as, '{search_term_string}', '?utm_source=google&utm_medium=sitesearch'),
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      {/* Make sure data layer is available */}
      <Script
        id="data-layer-script"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
          `,
        }}
      />

      <Script
        id="gtag-script"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${tagManagerId}');
          `,
        }}
      />
    </>
  );
};

export default GlobalScripts;
